import { Injectable } from '@angular/core';
import { Observable, catchError, map, of, shareReplay } from 'rxjs';
import { Ejercicio, EjerciciosService } from '../../api';

export interface EjercicioVigente {
  /** ID del ejercicio en Censo (historico.ejercicio guarda este ID; p. ej. 2027 = 14). */
  id: number;
  /** Año del ejercicio. */
  ejercicio: number;
}

/** El vigente es el ejercicio ACTIVO de Censo; si no hay ninguno marcado, el de mayor año. Nunca se supone el año natural. */
export function elegirVigente(lista: Ejercicio[]): EjercicioVigente | null {
  const vigente = lista.find(e => Boolean(e.active)) ?? [...lista].sort((a, b) => Number(b.ejercicio) - Number(a.ejercicio))[0];
  return vigente ? { id: Number(vigente.id), ejercicio: Number(vigente.ejercicio) } : null;
}

/** Ejercicio vigente de Censo (una sola petición compartida; si falla se reintenta la próxima vez). */
@Injectable({ providedIn: 'root' })
export class EjercicioVigenteService {
  private cache$: Observable<EjercicioVigente | null> | null = null;

  constructor(private readonly ejercicios: EjerciciosService) {}

  obtener(): Observable<EjercicioVigente | null> {
    if (!this.cache$) {
      this.cache$ = this.ejercicios.ejerciciosGet().pipe(
        map(res => elegirVigente(res.ejercicios ?? [])),
        catchError(() => { this.cache$ = null; return of(null); }),
        shareReplay(1)
      );
    }
    return this.cache$;
  }
}
